/**
 * Origin of the Lobu gateway for full-page navigations and public webhook
 * URLs. VITE_GATEWAY_URL wins for split frontend deployments; production and
 * `make dev` fall back to the current page origin.
 */
export function gatewayOrigin(
	env: ImportMetaEnv = import.meta.env,
	pageOrigin: string | undefined = typeof window !== "undefined"
		? window.location.origin
		: undefined,
): string {
	for (const raw of [env.VITE_GATEWAY_URL, env.VITE_API_URL]) {
		const value = typeof raw === "string" ? raw.trim() : "";
		if (!value) continue;
		try {
			return new URL(value).origin;
		} catch {
			// Ignore malformed values and fall through to the next source.
		}
	}
	return pageOrigin ?? "";
}
